declare global {
  interface Window {
    grecaptcha: any
  }
}

export const validateRecaptcha = async (client: any, recaptchaSiteKey: string | undefined): Promise<{ success: any, score: any }> => {
  return new Promise((resolve, reject) => {
    if (!recaptchaSiteKey) {
      reject(new Error('Recaptcha site key is not defined'))
    }
    window.grecaptcha.ready(function () {
      window.grecaptcha.execute(recaptchaSiteKey, { action: 'submit' }).then(async function (token: string) {
        await client
          .service('recaptcha')
          .create({
            token
          })
          .then(async (response: any) => {
            if (!response) {
              reject(new Error('Recaptcha validation failed'))
            }
            const { success, score } = response
            if (success) {
              if (score >= 0.5) {
                resolve(response)
              } else {
                reject(new Error('Recaptcha score is too low'))
              }
            } else {
              reject(new Error('Recaptcha validation failed'))
            }
          }).catch((error: any) => {
            reject(new Error('Recaptcha validation failed'))
          })
      })
    }) // End grecaptcha.ready
  })
}
